import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0d76278"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import LocalNavigationPanel from '@/components/NavigationPanel.vue'
	import BaseModal from '@/components/BaseModal.vue'

	import { keepAliveItems } from '@/router'
	import { ref, defineComponent, Ref } from 'vue'
	import { GlobalAlertService } from '@/services/GlobalAlertService';
	import { Alert } from '@/interfaces/Notification';

	interface Data {
		rail: Ref<Boolean>,
		alert: null | Alert,
		alertContext: GlobalAlertService,
	}

	const __default__ = defineComponent({
		data(): Data {
			return {
				rail: ref(false),
				alert: null,
				alertContext: GlobalAlertService
			}
		},
		mounted() {
			GlobalAlertService.setContext(this);
		},
		methods: {
			showAlert(alert: Alert) {
				this.alert = alert;
			},
		}
	});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MainLayout',
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseModal),
    _createVNode(LocalNavigationPanel, {
      propRail: _ctx.rail,
      "onUpdate:propRail": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rail) = $event))
    }, null, 8, ["propRail"]),
    _createElementVNode("main", {
      class: _normalizeClass({ 'compact': _ctx.rail, 'full': !_ctx.rail })
    }, [
      (_ctx.alert)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            class: "alert-modal",
            color: _ctx.alertContext.getAlertTypeName(_ctx.alert?.type),
            icon: _ctx.alertContext.getAlertTypeName(_ctx.alert?.type, '$'),
            closable: true
          }, {
            close: _withCtx(({ }) => [
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = null))
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("pre", {
                innerHTML: _ctx.alert?.message
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 8, ["color", "icon"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, { include: _unref(keepAliveItems) }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.fullPath
            }))
          ], 1032, ["include"]))
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})